import { isNil } from 'lodash-es'
import React, { FunctionComponent } from 'react'
import KolDetailStatistic, {
  KolDetailStatisticProps,
} from '@/components/kol/common/kol-detail-statistic'
import { useIntl } from '@/i18n/hooks/use-intl'
import { KpiSchema } from '@/types/schema/kpi-schema'

interface FollowerStatisticProps {
  loading?: KolDetailStatisticProps['loading']
  followerCount?: KpiSchema['follower']
}

const FollowerStatistic: FunctionComponent<FollowerStatisticProps> = ({
  loading,
  followerCount,
}) => {
  const { formatMessage, formatNumber } = useIntl()

  return (
    <KolDetailStatistic
      loading={loading}
      title={formatMessage({ id: 'campaign:followers_text' })}
      value={
        isNil(followerCount) || followerCount === 0
          ? 'noData'
          : formatNumber(followerCount)
      }
    />
  )
}

export default FollowerStatistic
